import { FormHelperText } from "@mui/material";
import { ChangeEvent, useContext } from "react";
import { BsFillKeyFill } from "react-icons/bs";
import { InputFile } from "../componentesGenerales/inputFile";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";

interface InputKeyPropsInterface {
  disabled?: boolean;
}
export const InputKey = ({ disabled = false }: InputKeyPropsInterface) => {
  const { keyFile, addKeyFile, readPrivateKey, handleAddKeySelected } =
    useContext(FirmaElectronicaContext);

  const handleChangeKey = (e: ChangeEvent<HTMLInputElement>) => {
    let name = e.target.files![0].name;
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files![0]);
    reader.onload = function () {
      const fileContent = reader.result;
      handleAddKeySelected({
        keyBase64: fileContent,
        name,
      });
    };
    readPrivateKey(e.target.files![0]);
    addKeyFile(e.target.files![0]);
    e.target.value = "";
  };

  return (
    <>
      <InputFile
        name="key"
        accept=".KEY"
        nameFile={keyFile?.name}
        helperText="Selecciona un archivo .KEY"
        handleChangeInputFile={(e) => handleChangeKey(e)}
        icon={<BsFillKeyFill />}
        disabled={disabled}
      />
      {keyFile?.name ? null : (
        <FormHelperText sx={{ color: "#f44336", paddingX: "15px" }}>
          La llave privada es un campo requerido
        </FormHelperText>
      )}
    </>
  );
};
